import type {
  BlogListItem,
  BlogPostDetail,
  ProjectDetail,
  ProjectListResponse,
} from "@rounak-portfolio/shared";

// Vite is not part of this stack, so there's no import.meta.env. Instead
// this relies on Bun's build-time env inlining, which does a literal
// textual replacement of `process.env.API_URL` with a string constant:
//   - `bun run build` (build.ts) passes an explicit `define` so the
//     production static bundle gets the real API origin baked in.
//   - `bun run dev` / `bun run start` (dev-server.ts / server.ts) go
//     through Bun.serve's HTML-import bundler, which picks up the
//     `[serve.static].define` default in bunfig.toml (localhost:8787, `wrangler dev`)
//     unless API_URL is set in the environment.
// Without one of these, `process` doesn't exist in the browser and this
// line would throw — so API_URL must always be defined at bundle time.
// "" means same-origin (production: the Worker serves /api alongside the site).
const API_BASE = process.env.API_URL ?? "";

async function apiFetch<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`);
  if (!res.ok) {
    throw new Error(`API ${path} failed: ${res.status}`);
  }
  return (await res.json()) as T;
}

export function fetchProjects(): Promise<ProjectListResponse> {
  return apiFetch<ProjectListResponse>("/api/projects");
}

export function fetchProject(slug: string): Promise<ProjectDetail> {
  return apiFetch<ProjectDetail>(`/api/projects/${slug}`);
}

export function fetchBlogPosts(): Promise<BlogListItem[]> {
  return apiFetch<BlogListItem[]>("/api/blog");
}

export function fetchBlogPost(slug: string): Promise<BlogPostDetail> {
  return apiFetch<BlogPostDetail>(`/api/blog/${slug}`);
}
